let grayscaleDarknessFactor = 1;

export const setGrayscaleDarknessFactor = (factor) => {
  grayscaleDarknessFactor = factor;
};

export const getGrayscaleDarknessFactor = () => grayscaleDarknessFactor;
